import { commonThinxHeaders, jsonGet, jsonPut } from 'api'

export const getWaitingListState = (waitingListSearchCode, token) =>
    jsonGet(
        `${window.THINX_BASE_WAITLIST_URL}/request/${waitingListSearchCode}`,
        null,
        commonThinxHeaders(token, true)
    ).catch(error => {
        throw new Error(error.message)
    })

export const subscribeWaitingList = (locale, requestId, token) =>
    jsonPut(
        `${window.THINX_BASE_WAITLIST_URL}/request/fulfill?locale=${locale}&requestId=${requestId}`,
        undefined,
        undefined,
        commonThinxHeaders(token, true)
    ).catch(error => {
        throw new Error(error.message)
    })
